export const LogoMark = ({ size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path d="M16 2v6.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    <path
      d="M8 19c0-4.8 3.6-8.5 8-8.5s8 3.7 8 8.5H8Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <circle cx="16" cy="21.5" r="1.8" fill="#D97706" />
    <path
      d="M16 25.5v2M11.5 24.5l-1.2 1.8M20.5 24.5l1.2 1.8"
      stroke="#D97706"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5 text-stone-900 dark:text-stone-50">
    <LogoMark />
    <span className="font-serif text-2xl font-medium tracking-tight">Hylasu</span>
  </span>
);
